// The data below is mapped into the Latest News section of the Landing Page.
import NewsCard2 from '../../Images/landing-page/news-card-2.png'
import NewsCard3 from '../../Images/landing-page/news-card-3.png'
import NewsCard4 from '../../Images/landing-page/news-card-4.png'


export const LATESTNEWSARRAY = [
    {
        image: NewsCard2,
        newsTag: 'PRESS RELEASE',
        headline: 'Class Technologies Inc. Closes $30 Million Series A Financing to Meet High Demand',
        details: 'Class Technologies Inc., the company that created Class,...'
    },
    {
        image: NewsCard3,
        newsTag: 'NEWS',
        headline: 'Zoom’s earliest investors are betting millions on a better Zoom for schools',
        details: 'Zoom was never created to be a consumer product. Nonetheless, the...'
    },
    {
        image: NewsCard4,
        newsTag: 'NEWS',
        headline: 'Former Blackboard CEO Raises $16M to Bring LMS Features to Zoom Classrooms',
        details: 'This year, investors have reaped big financial returns from betting on Zoom...'
    }
]